import { FiDownload, LoadingIcon } from "@pkg/icons";
import useDeviceType from "@/hooks/useDeviceType";
import { useDownloadLinks } from "@/hooks/useGrowthbookReady";
import { useLocation } from "@/lib/router";
import { POSTHOG_EVENT } from "@/services/posthog/data";
import eventTrackingHandler from "@/tracking/eventTrackingHandler";
import { cn } from "@/utils/cn";
import DownloadMessageMobile from "./DownloadMessageMobile";

type PlatformType = {
  [key: string]: string | undefined;
};

const DownloadLinks = ({
  darkBackPanel,
  className,
}: {
  darkBackPanel?: boolean;
  className?: string;
}) => {
  const { isDesktop } = useDeviceType();
  const location = useLocation();
  const downloadDataLinks = useDownloadLinks();

  const platforms: PlatformType = {
    "Apple Silicon": downloadDataLinks?.apple_m1,
    Windows: downloadDataLinks?.windows,
    "Intel Mac": downloadDataLinks?.apple_intel,
  };

  const appVersion = downloadDataLinks?.version;

  const handleEventRegiter = (deviceType: string) => {
    const downloadUrl = platforms?.[deviceType];
    const fileType = downloadUrl?.includes(".exe") ? "exe" : "dmg";

    eventTrackingHandler(POSTHOG_EVENT.DOWNLOAD_AFTERSHOOT_CTA_CLICKED, {
      types: ["posthog", "customerio"],
      properties: {
        device_type: deviceType,
        platform: deviceType,
        file_type: fileType,
        origin: location.pathname,
        source: "account_download_links",
        download_method: "manual",
      },
    });
  };

  return (
    <div className={cn("relative", className)}>
      {darkBackPanel && isDesktop && (
        <div className="bg-surface-black absolute top-0 h-[100px] w-full" />
      )}

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 xl:px-0">
        {isDesktop && (
          <div
            className={cn(
              "flex flex-col justify-between gap-4 rounded-2xl border border-edge-light bg-bone p-6 text-4xl sm:p-10 lg:flex-row lg:items-center",
              className,
            )}
          >
            <div className="s flex flex-col space-y-3" id="downloadApp">
              <div className="font-erode-variable text-[32px]">
                Download Aftershoot
              </div>

              {/* <div className="text-sm uppercase text-outrageousOrange tracking-[0.3]">
              now with Early Release of <br />
              AI Retouching
            </div> */}

              <div className="text-[14px] leading-[23.8px] font-normal tracking-[0.14px]">
                Grab the latest build to harness the full potential of our new
                white balance feature
              </div>
            </div>

            <div className="">
              <div className="flex flex-col justify-between gap-4 md:flex-row">
                {Object.keys(platforms).map((platform, i) => (
                  <a
                    key={i}
                    className="group relative flex items-center justify-between space-x-2 rounded-lg border border-nightRider bg-nightRider px-5 py-3 text-center text-base font-medium text-white transition-all duration-200 hover:cursor-pointer hover:bg-white hover:text-nightRider"
                    href={platforms?.[platform]}
                    target="_blank"
                    rel="noopener"
                    onClick={() => handleEventRegiter(platform)}
                  >
                    <FiDownload className="text-white group-hover:text-nightRider" />
                    <div>{platform}</div>
                    <div className="text-xs text-suvaGrey">
                      {appVersion ? (
                        appVersion
                      ) : (
                        <LoadingIcon className="h-4 w-5" />
                      )}
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
        <DownloadMessageMobile />
      </div>
    </div>
  );
};

export default DownloadLinks;
